import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "features/core/shared/test/data/test-harness.types";
import {Provider} from "@angular/core";
import {ObjectHouseholdComponent} from "../component/protected-components/object-household/object-household.component";
import {PersonSearchComponent} from "../component/protected-components/person-search/person-search.component";
import {PmPersonComponent} from "../component/protected-components/pm-person-component/pm-person.component";
import {
    PmCreatePersonWfProcessStepActivityComponent
} from "../component/protected-components/wf/pm-create-person-wf-process-step-activity/pm-create-person-wf-process-step-activity.component";
import {PmConfigPage} from "../page/overview/pm-config/pm-config.page";
import {PmStatisticsComponent} from "../page/pm-overview-page/components/statisticsComponent/pm-statistics.component";
import {PmKpiComponent} from "../page/pm-overview-page/components/kpiComponent/pm-kpi.component";
import {
    PersonSearchConsultantComponent
} from "../component/protected-components/consultant-component/person-search/person-search-consultant.component";


const pmModuleEntry: TestModuleDefinition = {
    key: 'pm',
    label: 'Person (pm)',
    components: [
        {
            key: 'ObjectHouseholdComponent',
            component: ObjectHouseholdComponent,
            selector: 'object-household-component',
            label: 'object household component',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'PersonSearchComponent',
            component: PersonSearchComponent,
            selector: 'pm-person-search-component',
            label: 'person search component',
            type: 'MvsSearchFlexibleBaseComponent',
        },
        {
            key: 'PmPersonComponent',
            component: PmPersonComponent,
            selector: 'pm-person',
            label: 'pm person',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'PmCreatePersonWfProcessStepActivityComponent',
            component: PmCreatePersonWfProcessStepActivityComponent,
            selector: 'mvs-wf-process-step-activity-object-create',
            label: 'wf process step activity object create',
            type: 'WfProcessStepActivityBaseComponent',
        },
        {
            key: 'PmConfigPage',
            component: PmConfigPage,
            selector: 'mvs-pm-config-page',
            label: 'PM Konfiguration',
            type: 'PageComponent',
        },
        {
            key: 'PmStatisticsComponent',
            component: PmStatisticsComponent,
            selector: 'pm-statistics-component',
            label: 'pm statistics component',
            type: 'OverviewStatisticsBaseComponent',
        },
        {
            key: 'PmKpiComponent',
            component: PmKpiComponent,
            selector: 'pm-kpi-component',
            label: 'pm kpi component',
            type: 'OverviewKpiBaseComponent',
        },
        {
            key: 'PersonSearchConsultantComponent',
            component: PersonSearchConsultantComponent,
            selector: 'pm-person-search-consultant-component',
            type: 'PersonSearchComponent',
            label: 'person search consultant component'
        },
        {
            key: 'PersonSearchConsultantComponent',
            component: PersonSearchConsultantComponent,
            selector: 'pm-person-search-consultant-component',
            type: 'PersonSearchComponent',
            label: 'person search consultant component'
        },
    ]
};

export const PM_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: pmModuleEntry, multi: true }
];